import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withExperiments} from 'wix-experiments-react';
import '../../styles/message.scss';
import get from 'lodash/get';
import {resendMessage, uploadFile} from '../../actions';
import Image from '../Image/Image';
import Attachment from '../Attachment/Attachment';
import MessageError from '../MessageError/MessageError';
import {emojiReplaceNodeChildren, shouldReplaceWithEmojiImg} from '../../utils/emojiUnicodeToImage';
import {urlify, relativeDate} from '../../utils/utils';

class Message extends React.Component {

  componentDidMount() {
    if (this.props.message.dateTime) {
      this.forceUpdate();
    }
    if (shouldReplaceWithEmojiImg()) {
      emojiReplaceNodeChildren(this.content);
    }
  }

  componentDidUpdate() {
    setTimeout(this.forceUpdate.bind(this), 60000);
  }

  getComponent(messagePart, messageStyle, isUploading) {
    if (messagePart.contentType === 'text') {
      return <div ref={content => this.content = content} className="message-content" style={messageStyle}>{urlify(messagePart.text)}</div>;
    } else if (messagePart.contentType.startsWith('image')) {
      return (
        <div>
          <Image media={messagePart} uploading={isUploading}/>
          {this.addErrorIfNeeded(messagePart)}
        </div>
      );
    } else {
      return (
        <div>
          <Attachment media={messagePart} uploading={isUploading}/>
          {this.addErrorIfNeeded(messagePart)}
        </div>
      );
    }
  }

  addErrorIfNeeded(messagePart) {
    return messagePart.error && messagePart.file ? <div><MessageError handleTryAgain={() => this.props.reUploadFile(messagePart.file, this.props.message)}/></div> : null;
  }

  render() {
    const {message, isLastInSequence, chatSettings, experiments} = this.props;
    const isIncomingMessage = () => {
      return message.direction === 'BUSINESS_TO_CUSTOMER';
    };

    const messageStyle = {
      borderRadius: get(chatSettings, 'design.selectedRadiusOption') + 'px'
    };

    const getErrorFooter = () => <MessageError handleTryAgain={() => this.props.resendMessage(message)}/>;

    const getMessageFooter = (message, isLast) => {
      const date = message.dateTime && relativeDate(message.dateTime);
      if (message.error) {
        return getErrorFooter();
      }
      if (!message.error && !message.dateTime) {
        return (<span className="sending-message">
          <span className="sending-text"> Sending </span>
          { message.content ? <span className="sending-loader"/> : null }
        </span>);
      }
      return isLast ? <span className="message-date">{date}</span> : null;
    };

    const className = `message ${isIncomingMessage() ? 'in' : 'out'}`;

    const avatarStyle = get(chatSettings, 'design.selectedImageOption') === '3' ? {background: `url("${chatSettings.design.customImgUrl}")`} : {};

    const messageMedia = experiments.enabled('specs.com.VisitorAttachments') && message.media ? message.media : [];

    const messageParts = [...messageMedia];

    const content = message.content;
    if (content) {
      messageParts.push({contentType: 'text', text: content});
    }

    const totalMessageParts = messageParts.length;

    return (
      <div className="message-container">
        {
          totalMessageParts > 0 ? messageParts.map((messagePart, index) => {
            const lastInMessage = totalMessageParts - 1 === index;
            return (
              <div className={className} key={index}>
                <div className="message-top-row">

                  {isLastInSequence && lastInMessage ? <span className="avatar" style={avatarStyle}/> : null}
                  {this.getComponent(messagePart, messageStyle, message.uploadingFile)}
                </div>
                {!messagePart.error ? getMessageFooter(message, isLastInSequence && lastInMessage) : null}
              </div>
            );
          }) : null
        }
      </div>
    );
  }
}

Message.propTypes = {
  message: PropTypes.object,
  isLastInSequence: PropTypes.bool,
  chatSettings: PropTypes.object,
  resendMessage: PropTypes.func,
  reUploadFile: PropTypes.func,
  experiments: PropTypes.any
};

function mapStateToProps(state) {
  return {
    chatSettings: state.chatSettings
  };
}

const mapDispatchToProps = dispatch => ({
  resendMessage: message => dispatch(resendMessage(message, message.activityId)),
  reUploadFile: (file, message) => dispatch(uploadFile(file, message.activityId))
});

export default withExperiments(connect(mapStateToProps, mapDispatchToProps)(Message));



// WEBPACK FOOTER //
// ./chat-app/components/Message/Message.js